/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Component } from 'react';
import UrlConstants from '../../../constants/UrlConstants';
import { Dispatch } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container } from '@mui/material';
import { List as ImmutableList } from 'immutable';
import { RootState } from '../../../setup';
import { Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStyles, withStyles } from '@mui/styles';
import IMenuItem from '../../../interfaces/common/menuItem';
import Paging from '../../../interfaces/common/paging';
import Pagination from '../../../interfaces/common/pagination';
import MainLayout from '../../common/widgets/mainLayout';
import PageUtils from '../../../utils/pageUtils';
import { Theme } from '@mui/material';
import FactorSetOut from '../../../interfaces/output/factorSetOut';
import { ObjectType } from '../../../constants/constants';
import LanguageUtils from '../../../utils/LanguageUtils';
import Loader from '../../common/widgets/loader';
import FactorsVersionsList from '../factorsVersionList';
import FactorSetVersionOut from '../../../interfaces/output/factorSetVersionOut';
import {
    deactivateFactorSetCalendar, fetchFactorSetCalendarById, getFactorSetCalendar, isDeletingCalendar, isLoadingFactorSetCalendar, isLoadingFactorSetCalendars,
    resetFactorSetCalendar, resetFactorSetCalendars
} from '../../../reducers/factorSetCalendarReducer';
import {
    deactivateFactorSetCalendarLine, fetchCalendarVersionLines, getCalendarLines, isCreatingCalendarLine, isDeletingCalendarLine, isLoadingFactorSetCalendarLines, isUpdatingCalendarLine,
    resetCalendarVersionLines
} from '../../../reducers/calendarLineReducer';
import FactorSetCalendarLineOut from '../../../interfaces/output/factorSetCalendarLineOut';
import CalendarLineFilters from './line/calendarLineFilters';
import { fetchCalendarVersions, getFactorSetCalendarVersions, isLoadingFactorSetCalendarVersions } from '../../../reducers/factorSetCalendarVersionReducer';
import ViewFactorSetCalendar from './viewCalendar';
import ViewFactorSetCalendarLines from './line/calendarLinesList';
import NullableFormattedDate from '../../common/nullableFormattedDate';
import { GridSortModel, GridSortDirection, GridSortItem, GridColumnVisibilityModel } from '@mui/x-data-grid';

interface IFactorSetCalendarDetailsProps {
    classes: any;
    theme: Theme;
    fetchFactorSetCalendarById: any;
    fetchCalendarVersionLines: any;
    deactivateFactorSetCalendar: any;
    deactivateFactorSetCalendarLine: any;
    fetchCalendarVersions: any;
    resetFactorSetCalendar: () => any;
    resetCalendarVersionLines: () => any;
    resetFactorSetCalendars: () => any;
    factorSetCalendar: FactorSetOut;
    match: any;
    calendarLines: Pagination<FactorSetCalendarLineOut>;
    factorVersions: Pagination<FactorSetVersionOut>;
    history: any;
    location: any;
    isUpdatingCalendar: boolean;
    isDeletingCalendar: boolean;
    isDeletingLine: boolean;
    isCreatingCalendar: boolean;
    isLoading: boolean;
    isLoadingFactorSetCalendar: boolean;
    isLoadingFactorSetCalendarLines: boolean;
    isLoadingFactorSetVersions: boolean;
}

interface IFactorSetCalendarDetailsState {
    open: boolean;
    factorSetCalendar: FactorSetOut;
    menuItems: ImmutableList<IMenuItem>;
    selectedRow?: number;
    serverPagination: Paging;
    serverPaginationLines: Paging;
    sortModelLines: GridSortModel;
    sortModelVersions: GridSortModel;
    factorSetCalendarColumnVisibilityModel: GridColumnVisibilityModel;
    factorsVersionLinesColumnVisibilityModel: GridColumnVisibilityModel;
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchFactorSetCalendarById: (id: number, versionId: number) => dispatch(fetchFactorSetCalendarById({
        factorSetId: id,
        versionId
    })),
    fetchCalendarVersionLines: (paging: Paging, filters: CalendarLineFilters) => dispatch(fetchCalendarVersionLines({
        paging,
        filters
    })),
    fetchCalendarVersions: (id: number, paging: Paging) => dispatch(fetchCalendarVersions({
        id,
        paging
    })),
    deactivateFactorSetCalendar: (id: number) => dispatch(deactivateFactorSetCalendar(id)),
    deactivateFactorSetCalendarLine: (id: number) => dispatch(deactivateFactorSetCalendarLine(id)),
    resetFactorSetCalendar: () => dispatch(resetFactorSetCalendar()),
    resetFactorSetCalendars: () => dispatch(resetFactorSetCalendars()),
    resetCalendarVersionLines: () => dispatch(resetCalendarVersionLines())
});

const mapStoreToProps = (store: RootState) => {
    return {
        factorSetCalendar: getFactorSetCalendar(store),
        calendarLines: getCalendarLines(store),
        factorVersions: getFactorSetCalendarVersions(store),
        isUpdatingCalendar: isUpdatingCalendarLine(store),
        isDeletingLine: isDeletingCalendarLine(store),
        isDeletingCalendar: isDeletingCalendar(store),
        isCreatingCalendar: isCreatingCalendarLine(store),
        isLoadingFactorSetCalendarLines: isLoadingFactorSetCalendarLines(store),
        isLoadingFactorSetVersions: isLoadingFactorSetCalendarVersions(store),
        isLoading: isLoadingFactorSetCalendars(store) || isUpdatingCalendarLine(store) || isDeletingCalendarLine(store) || isCreatingCalendarLine(store) ||
            isLoadingFactorSetCalendarLines(store),
        isLoadingFactorSetCalendar: isLoadingFactorSetCalendar(store)
    };
};

const styles = (theme: Theme) => createStyles({
    container: {
        padding: theme.spacing(4)
    },
    link: {
        textDecoration: 'none',
        color: `${theme.palette.info.main}!important`,
        fontSize: '12px!important'
    },
    extraSpace: {
        marginRight: theme.spacing(1)
    },
    values: {
        color: theme.palette.common.black
    }
});

const messages = {
    edit: LanguageUtils.createMessage('Edit'),
    add: LanguageUtils.createMessage('Add'),
    delete: LanguageUtils.createMessage('Delete'),
    subname: LanguageUtils.createMessage('FACTOR_SET_CALENDAR'),
    properties: LanguageUtils.createMessage('Properties'),
    changeStatus: LanguageUtils.createMessage('Change version status'),
    versions: LanguageUtils.createMessage('Versions'),
    factors: LanguageUtils.createMessage('lines')
};

class FactorSetCalendarDetails extends Component<IFactorSetCalendarDetailsProps, IFactorSetCalendarDetailsState> {
    factorsVersionListRef: any;
    factorsVersionLineListRef: any;

    constructor(props: IFactorSetCalendarDetailsProps) {
        super(props);
        this.factorsVersionListRef = React.createRef();
        this.factorsVersionLineListRef = React.createRef();

        this.state = {
            open: true,
            factorSetCalendar: {} as FactorSetOut,
            menuItems: this.configureDrawer(props),
            selectedRow: undefined,
            serverPagination: PageUtils.getDefaultPaging(),
            serverPaginationLines: PageUtils.getDefaultPaging(),
            sortModelLines: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            sortModelVersions: [{
                field: '',
                sort: '' as GridSortDirection
            } as GridSortItem],
            factorSetCalendarColumnVisibilityModel: {},
            factorsVersionLinesColumnVisibilityModel: {}
        };
    }

    componentDidMount() {
        const { fetchFactorSetCalendarById } = this.props;
        const { calendarId, factorSetVersionId } = this.props.match.params;
        const versionId = factorSetVersionId === 'latest' ? undefined : factorSetVersionId;

        fetchFactorSetCalendarById(calendarId, versionId);
    }

    componentWillUnmount() {
        const { resetFactorSetCalendar, resetFactorSetCalendars, resetCalendarVersionLines } = this.props;

        resetFactorSetCalendar();
        resetFactorSetCalendars();
        resetCalendarVersionLines();
    }

    componentDidUpdate(prevProps: IFactorSetCalendarDetailsProps) {
        const { factorSetCalendar, isUpdatingCalendar, isDeletingLine, isCreatingCalendar, isLoadingFactorSetCalendar, isDeletingCalendar, history,
            fetchFactorSetCalendarById } = this.props;
        const selectedMenuItem = this.getSelectedMenuItem(this.state);
        const { calendarId, factorSetVersionId } = this.props.match.params;

        if(factorSetCalendar !== prevProps.factorSetCalendar) {
            this.setState({ factorSetCalendar });
        }

        if(prevProps.location.pathname && this.props.location.pathname !== prevProps.location.pathname) {
            this.setState({
                menuItems: this.configureDrawer(this.props),
                selectedRow: undefined
            }, () => this.loadData(this.getSelectedMenuItem(this.state)));

            if(prevProps.match.params.factorSetVersionId !== factorSetVersionId) {
                const versionId = factorSetVersionId === 'latest' ? undefined : factorSetVersionId;
                fetchFactorSetCalendarById(calendarId, versionId);
            }
        }

        if(selectedMenuItem && (!isLoadingFactorSetCalendar && prevProps.isLoadingFactorSetCalendar ||
            !isUpdatingCalendar && prevProps.isUpdatingCalendar ||
            !isDeletingLine && prevProps.isDeletingLine ||
            !isCreatingCalendar && prevProps.isCreatingCalendar)) {
            this.loadData(selectedMenuItem);
        }

        if(!isDeletingCalendar && prevProps.isDeletingCalendar) {
            history.push(`/${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}`);
        }
    }

    isHiddenCategory = (): boolean => {
        const { factorSetCalendar } = this.state;

        return factorSetCalendar.version?.id ? false : true;
    }

    configureDrawer = (props: IFactorSetCalendarDetailsProps): ImmutableList<IMenuItem> => {
        const baseUrl = `/${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${props.match.params.calendarId}/${props.match.params.factorSetVersionId}`;

        return ImmutableList([{
            id: 1,
            name: messages.properties,
            icon: <FontAwesomeIcon icon="info-circle" size="1x" transform="grow-4" />,
            additionalMargin: true,
            url: `${baseUrl}/properties`,
            isSelected: PageUtils.isPageSelected(`${baseUrl}/properties`, props.location.pathname)
        },
        {
            id: 2,
            name: messages.versions,
            additionalMargin: true,
            icon: <FontAwesomeIcon icon="layer-group" size="1x" transform="grow-4" />,
            url: `${baseUrl}/versions`,
            isSelected: PageUtils.isPageSelected(`${baseUrl}/versions`, props.location.pathname)
        },
        {
            id: 3,
            name: messages.factors,
            icon: <FontAwesomeIcon icon="grip-lines" size="1x" transform="grow-4" />,
            url: `${baseUrl}/lines`,
            isSelected: PageUtils.isPageSelected(`${baseUrl}/lines`, props.location.pathname),
            isHidden: this.isHiddenCategory
        }]);
    }

    loadData = (selectedMenuItem: IMenuItem | undefined) => {
        const { fetchCalendarVersionLines, factorSetCalendar, fetchCalendarVersions } = this.props;
        const { calendarId } = this.props.match.params;
        const { serverPagination, serverPaginationLines } = this.state;

        const lineFilters = {
            name: undefined,
            calendarTypeId: null,
            factorSetVersionId: factorSetCalendar.version?.id
        } as CalendarLineFilters;

        const newPaging = PageUtils.getDefaultPaging();
        const newPagination = {
            ...serverPagination,
            page: newPaging.page
        };

        const newPaginationLines = {
            ...serverPaginationLines,
            page: newPaging.page
        };

        if(selectedMenuItem?.id === 2) {
            fetchCalendarVersions(calendarId, newPagination);
        }

        if(selectedMenuItem?.id === 3 && factorSetCalendar.version?.id) {
            fetchCalendarVersionLines(newPaginationLines, lineFilters);
        }
    }

    getSelectedMenuItem = (state: IFactorSetCalendarDetailsState) => state.menuItems.find(item => item.isSelected);

    deactivateFactorSet = () => {
        const { factorSetCalendar } = this.state;
        const { deactivateFactorSetCalendar } = this.props;

        deactivateFactorSetCalendar(factorSetCalendar.id);
    }

    deactivateFactorSetLine = () => {
        const { selectedRow } = this.state;
        const { deactivateFactorSetCalendarLine } = this.props;

        deactivateFactorSetCalendarLine(selectedRow);
    }

    handleMenuItems = () => {
        const { menuItems, selectedRow, factorSetCalendar } = this.state;
        const { calendarLines } = this.props;
        const selectedMenuItem = menuItems.find((item: IMenuItem) => item.isSelected);
        const selectedMenuItemId = selectedMenuItem?.id;
        const { calendarId } = this.props.match.params;

        switch (selectedMenuItemId) {
            case 1: { //details
                return [
                    {
                        href: factorSetCalendar.version?.id ? `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/${factorSetCalendar.version?.id}/edit` :
                            `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/edit`,
                        icon: 'edit',
                        text: messages.edit
                    },
                    {
                        icon: 'ban',
                        text: messages.delete,
                        onClick: this.deactivateFactorSet
                    }
                ];
            }

            case 2: { //calendar versions
                if(!selectedRow) {
                    return [
                        {
                            href: `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/add/version`,
                            icon: 'plus',
                            text: messages.add
                        }
                    ];
                }

                return [{
                    href: `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/version/${selectedRow}/edit`,
                    icon: 'edit',
                    text: messages.edit
                },
                {
                    href: `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/version/${selectedRow}/status`,
                    icon: 'retweet',
                    text: messages.changeStatus
                }];
            }

            case 3: { //lines
                if(!selectedRow) {
                    return [
                        {
                            href: `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/version/${factorSetCalendar.version?.id}/add/line`,
                            icon: 'plus',
                            text: messages.add,
                            disabled: !factorSetCalendar.version?.id
                        }
                    ];
                }

                if(factorSetCalendar.version) {
                    return [
                        {
                            href: `${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/${calendarId}/version/${factorSetCalendar.version?.id}/calendarLine/${selectedRow}/edit`,
                            icon: 'edit',
                            text: messages.edit
                        },
                        {
                            icon: 'ban',
                            text: messages.delete,
                            onClick: this.deactivateFactorSetLine
                        }
                    ];
                }

                return [];
            }

            default: {
                return [];
            }
        }
    }

    _onSortChangeLines = (newModel: GridSortModel) => {
        const { fetchCalendarVersionLines } = this.props;
        const { sortModelLines, serverPaginationLines, factorSetCalendar } = this.state;

        const lineFilters = {
            name: undefined,
            calendarTypeId: null,
            factorSetVersionId: factorSetCalendar.version?.id
        } as CalendarLineFilters;

        if(JSON.stringify(sortModelLines) !== JSON.stringify(newModel)) {
            const newPagination = {
                ...serverPaginationLines,
                sort: newModel
            };
            this.setState({
                sortModelLines: newModel,
                serverPaginationLines: newPagination
            });

            fetchCalendarVersionLines(newPagination, lineFilters);
        }
    }

    _onSortChangeVersions = (newModel: GridSortModel) => {
        const { fetchCalendarVersions } = this.props;
        const { factorSetCalendar, serverPagination, sortModelVersions } = this.state;

        if(JSON.stringify(sortModelVersions) !== JSON.stringify(newModel)) {
            const newPagination = {
                ...serverPagination,
                sort: newModel
            };
            this.setState({
                sortModelVersions: newModel,
                serverPagination: newPagination
            });

            fetchCalendarVersions(factorSetCalendar.id, newPagination);
        }
    }

    render() {
        const { classes, isLoadingFactorSetCalendar, isLoadingFactorSetCalendarLines, calendarLines, isDeletingLine, isDeletingCalendar, isUpdatingCalendar,
            isLoadingFactorSetVersions, factorVersions, fetchCalendarVersions, fetchCalendarVersionLines } = this.props;
        const { factorSetCalendar, menuItems, serverPagination, serverPaginationLines, factorSetCalendarColumnVisibilityModel, factorsVersionLinesColumnVisibilityModel } = this.state;

        return (
            <MainLayout actions={this.handleMenuItems()}
                isLoading={isLoadingFactorSetCalendar || isDeletingCalendar}
                menuItems={menuItems}
                includeDrawer
                objectType={ObjectType.FactorSets}
                menuItem={{
                    id: 1,
                    subname: messages.subname,
                    value: factorSetCalendar.name,
                    icon: <FontAwesomeIcon icon="calendar-check" size="1x" />
                } as IMenuItem}
                additionalElement={
                    <strong>
                        <span className={classes.extraSpace}> <FontAwesomeIcon icon="layer-group" size="1x" transform="grow-3" className={classes.extraSpace} />
                            <span className={classes.values}> {factorSetCalendar?.version?.versionNumber ?? '-'} </span>
                        </span>
                        <span>
                            <FontAwesomeIcon icon="calendar-alt" size="1x" transform="grow-3" className={classes.extraSpace} />
                            {factorSetCalendar?.version?.validFromDate || factorSetCalendar?.version?.validToDate ? (
                                <span className={classes.values}>
                                    <NullableFormattedDate value={factorSetCalendar?.version?.validFromDate} /> -
                                    {factorSetCalendar?.version?.validToDate &&
                                        <> <NullableFormattedDate value={factorSetCalendar?.version?.validToDate} /></>}
                                </span>
                            )
                                : '-'} </span>
                    </strong>
                }
            >
                <Container className={classes.container} maxWidth="xl">
                    <Switch>
                        <Route path={`/${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/:calendarId/:factorSetVersionId/properties`}>
                            <Loader isLoading={isUpdatingCalendar || isDeletingCalendar}>
                                <ViewFactorSetCalendar factorSetCalendar={factorSetCalendar} />
                            </Loader>
                        </Route>
                        <Route path={`/${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/:calendarId/:factorSetVersionId/lines`}>
                            <ViewFactorSetCalendarLines isLoading={isLoadingFactorSetCalendarLines || isDeletingLine}
                                rows={calendarLines}
                                checkSelection={(value: number) => this.setState({ selectedRow: value })}
                                onPageChange={(nextPage: number, nextSize: number) => {
                                    const newPage = {
                                        ...serverPaginationLines,
                                        page: nextPage,
                                        size: nextSize
                                    };
                                    const lineFilters = {
                                        name: undefined,
                                        calendarTypeId: null,
                                        factorSetVersionId: factorSetCalendar.version?.id
                                    } as CalendarLineFilters;
                                    this.setState({ serverPaginationLines: newPage });
                                    fetchCalendarVersionLines(newPage, lineFilters);
                                }}
                                onSortModelChange={(sortModel: GridSortModel) => this._onSortChangeLines(sortModel)}
                                columnVisibilityModel={factorSetCalendarColumnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel : GridColumnVisibilityModel) =>
                                    this.setState({
                                        factorSetCalendarColumnVisibilityModel: newModel
                                    })
                                }
                            />
                        </Route>
                        <Route path={`/${UrlConstants.FACTOR_SETS}/${UrlConstants.FACTOR_SET_CALENDAR}/:calendarId/:factorSetVersionId/versions`}>
                            <FactorsVersionsList
                                type={factorSetCalendar.type?.code}
                                isLoading={isLoadingFactorSetVersions}
                                ref={this.factorsVersionListRef}
                                rows={factorVersions} checkSelection={(value: number) => this.setState({ selectedRow: value })}
                                onPageChange={(nextPage: number, nextSize: number) => {
                                    const newPage = {
                                        ...serverPagination,
                                        page: nextPage,
                                        size: nextSize
                                    };
                                    fetchCalendarVersions(factorSetCalendar.id, newPage);
                                    this.setState({ serverPagination: newPage });
                                }}
                                onSortModelChange={(sortModel: GridSortModel) => this._onSortChangeVersions(sortModel)}
                                columnVisibilityModel={factorsVersionLinesColumnVisibilityModel}
                                onColumnVisibilityModelChange={(newModel : GridColumnVisibilityModel) =>
                                    this.setState({
                                        factorsVersionLinesColumnVisibilityModel: newModel
                                    })
                                }
                            />
                        </Route>
                    </Switch>
                </Container>
            </MainLayout>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(FactorSetCalendarDetails));